import { render, staticRenderFns } from "./ReviewSortMenu.vue?vue&type=template&id=26fce1ba&scoped=true&"
import script from "./ReviewSortMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewSortMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSortMenu.vue?vue&type=style&index=0&id=26fce1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fce1ba",
  null
  
)

export default component.exports